import { type RefObject, useEffect } from 'react';

import { setIsPaused, setIsPlaying } from '../state/AudioPlayerState';

type UseAudioPlaybackSyncProps = {
	audioRef: RefObject<HTMLAudioElement>;
};

export const useAudioPlaybackSync = ({ audioRef }: UseAudioPlaybackSyncProps) => {
	useEffect(() => {
		const audio = audioRef.current;
		if (!audio) {
			return;
		}

		const onPlay = () => {
			setIsPlaying(true);
		};

		const onPause = () => {
			setIsPlaying(false);
			if (audio.src && audio.src !== '') {
				setIsPaused(true);
			}
		};

		const onEnded = () => {
			setIsPlaying(false);
			setIsPaused(false);
		};

		const onCanPlay = () => {
			if (audio.currentTime < audio.duration) {
				audio.play();
			}
		};

		// Time tracking handlers
		// const onTimeUpdate = () => {
		//     updatePlaybackState({
		//         currentTime: audio.currentTime,
		//         duration: audio.duration || 0,
		//     });
		// };

		// const onLoadedMetadata = () => {
		//     setDuration(audio.duration || 0);
		// };

		// const onDurationChange = () => {
		//     setDuration(audio.duration || 0);
		// };

		// Attach event listeners
		audio.addEventListener('play', onPlay);
		audio.addEventListener('pause', onPause);
		audio.addEventListener('canplay', onCanPlay);
		audio.addEventListener('ended', onEnded);
		// audio.addEventListener('timeupdate', onTimeUpdate);
		// audio.addEventListener('loadedmetadata', onLoadedMetadata);
		// audio.addEventListener('durationchange', onDurationChange);

		return () => {
			// Cleanup event listeners
			audio.removeEventListener('play', onPlay);
			audio.removeEventListener('pause', onPause);
			audio.removeEventListener('canplay', onCanPlay);
			audio.removeEventListener('ended', onEnded);
			// audio.removeEventListener('timeupdate', onTimeUpdate);
			// audio.removeEventListener('loadedmetadata', onLoadedMetadata);
			// audio.removeEventListener('durationchange', onDurationChange);
		};
	}, [audioRef]);
};
